import React from 'react';
import './ImageStyleSheet.css';

function ImageInkFour() {
    window.scrollTo(0,0);
    return (
        <div className="container">
           <img src="/images/7ink4.jpg" className='img-view'/> 
        </div>
    )
}

export default ImageInkFour
